export enum RoleEnum {
    Unknown = 0,
    CAS = 1,
    Administrator = 2,
  }